export enum Roles {
    NOROLE = 'NOROLE',
    ADMIN = 'ADMIN',
    COURT = 'COURT',
    DISABLED = 'DISABLED'
}
